import { IconProps } from "../../types/icon";

export default function CheckIcon ({className = ""}: IconProps) {
  return (
    <svg className={className} width="13.5px" height="12.7px" viewBox="0 0 13.5 12.7">
      <path d="M3.1,11.7c-0.7-0.7-1.2-1.5-1.7-2.2c-0.5-0.6-0.9-1.3-1.2-2C0,7-0.1,6.6,0.3,6.3 c1.3-0.8,1.6,0,2.3,0.9c0.4,0.5,1.1,1.4,1.4,2c0.4,0.5,0.8-0.4,1-0.7c0.7-1,2.3-3.3,3-4.2c0.7-0.8,2.8-3.2,3.2-3.5 c0.3-0.3,1.1-1,1.5-0.6c0.5,0.4,0.7,1.1,0.4,1.7c-0.6,0.9-1.6,1.7-2.3,2.5C9.7,5.9,8.4,7.7,7.1,9.5c-0.4,0.6-1,1.6-1.4,2.3 C5.1,13,4.5,13.2,3.1,11.7z" fill="currentColor" />
    </svg>
  )
}